(() => {
  const badgeSelector = '[data-hh-bestseller-product]';
  const configSelector = '[data-hh-bestseller-config]';
  let rankedIds = new Set();

  function applyBadge(badge) {
    badge.hidden = !rankedIds.has(badge.dataset.hhBestsellerProduct);
  }

  function applyBadges(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.(badgeSelector)) applyBadge(root);
    root.querySelectorAll(badgeSelector).forEach(applyBadge);
  }

  function acceptRanking(config) {
    const count = Math.max(1, Math.min(30, Number(config.count) || 10));
    rankedIds = new Set(config.enabled && Array.isArray(config.ids) ? config.ids.slice(0, count).map(String) : []);
    applyBadges(document);
    document.documentElement.dataset.hhBestsellerState = 'ready';
  }

  async function loadRanking(config) {
    if (!config.refresh) {
      acceptRanking(config);
      return;
    }

    const url = new URL(config.endpoint, window.location.origin);
    if (url.origin !== window.location.origin) return;
    url.searchParams.set('section_id', 'hh-bestseller-ranking');
    const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 8000);

    try {
      const response = await fetch(url.toString(), { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('Bestseller ranking unavailable');
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const ranking = parsed.querySelector(configSelector);
      if (!ranking) throw new Error('Bestseller ranking missing');
      acceptRanking(JSON.parse(ranking.textContent));
    } catch {
      rankedIds = new Set();
      applyBadges(document);
      document.documentElement.dataset.hhBestsellerState = 'unavailable';
    } finally {
      window.clearTimeout(timeout);
    }
  }

  function start() {
    const element = document.querySelector(configSelector);
    if (!element) return;
    let config;
    try {
      config = JSON.parse(element.textContent);
    } catch {
      return;
    }

    const observer = new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'attributes') applyBadge(record.target);
        else record.addedNodes.forEach(applyBadges);
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-hh-bestseller-product']
    });
    loadRanking(config);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
